import React from 'react';
import CombinedDashboard from './components/combined-dashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <CombinedDashboard />
    </div>
  );
}

export default App;